export function Sparkline({
  values, stroke = '#ff5a1f', width = 80, height = 32, className,
}: { values: number[]; stroke?: string; width?: number; height?: number; className?: string }) {
  if (!values || values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const step = width / (values.length - 1);
  const pts = values
    .map((v, i) => `${(i * step).toFixed(2)},${(height - ((v - min) / span) * height).toFixed(2)}`)
    .join(' ');
  return (
    <svg width={width} height={height} className={className} fill="none" aria-hidden>
      <polyline points={pts} stroke={stroke} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
